import type { User } from "firebase/auth";
import {
  doc,
  getDoc,
  serverTimestamp,
  setDoc,
  updateDoc,
  type Firestore,
} from "firebase/firestore";

export async function ensureUserProfile(db: Firestore, user: User) {
  if (!user.email) {
    throw new Error("A Google account with an email address is required.");
  }

  const profileRef = doc(db, "users", user.uid);
  const snapshot = await getDoc(profileRef);

  if (snapshot.exists() && snapshot.data().status === "disabled") {
    throw new Error("This Master Notes account has been disabled.");
  }

  if (snapshot.exists()) {
    await updateDoc(profileRef, {
      displayName: user.displayName ?? user.email.split("@")[0],
      photoURL: user.photoURL ?? null,
      updatedAt: serverTimestamp(),
      lastLoginAt: serverTimestamp(),
    });
    return;
  }

  await setDoc(profileRef, {
    uid: user.uid,
    email: user.email,
    displayName: user.displayName ?? user.email.split("@")[0],
    photoURL: user.photoURL ?? null,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
    lastLoginAt: serverTimestamp(),
    status: "active",
  });
}
